import React, { createContext, useCallback, useContext, useState } from 'react';

import { useTranslation } from 'react-i18next';

interface LanguageContextType {
  currentLanguage: string;
  setLanguageFromClinic: (language: string | null | undefined) => void;
  t: (key: string, options?: any) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined
);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const { i18n, t } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  const setLanguageFromClinic = useCallback(
    (language: string | null | undefined) => {
      const supportedLanguage = language === 'tl' ? 'tl' : 'en';
      i18n.changeLanguage(supportedLanguage);
      setCurrentLanguage(supportedLanguage);
    },
    [i18n]
  );

  return (
    <LanguageContext.Provider
      value={{ currentLanguage, setLanguageFromClinic, t }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
